<template>
  <el-drawer
    @close="closeDrawer"
    append-to-body
    :visible.sync="visible"
    class="search-popup"
    direction="rtl"
    size="30%"
  >
    <el-form>
      <el-form-item :label="$t('27')">
        <el-popover
          popper-class="tree-popover"
          v-model="popover"
          width="300"
          :offset="-20"
          ref="treePopover"
          placement="bottom"
          trigger="click"
        >
          <el-tree
            node-key="department_id"
            ref="tree"
            lazy
            show-checkbox
            highlight-current
            :data="treeList"
            :props="treeProps"
            :load="loadNode"
            :accordion="true"
            :default-checked-keys="defaultCheckedKeys"
            :default-expanded-keys="defaultExpandedKeys"
            @check-change="handleNodeClick"
          >
          </el-tree>
        </el-popover>

        <div class="input">
          <el-input
            class="input"
            v-model="name"
            v-popover:treePopover
            :placeholder="treeCheckList.length ? '' : $t('794')"
            clearable
            suffix-icon="el-icon-arrow-down"
          />
          <div v-if="treeCheckList.length" class="check-list">
            <div class="tag">
              <el-tag closable type="info" size="small" @close="departmentClear">
                {{ treeCheckList[0].department_name }}
              </el-tag>
              <el-tag type="info" size="small" class="text" v-if="treeCheckList.length > 1">
                + {{ treeCheckList.length - 1 }}
              </el-tag>
            </div>
          </div>
        </div>
      </el-form-item>
      <!-- 结算类型 -->
      <el-form-item :label="$t('payroll_salary_24')" v-if="pageName === 'salary'">
        <el-checkbox-group v-model="dataForm.settlement_type" @change="settlementTypeChange">
          <el-checkbox-button
            v-for="(item, index) in sysInfoData.settlement_type"
            :key="index"
            :value="item.key"
            :label="item.key"
            >{{ item.value }}</el-checkbox-button
          >
        </el-checkbox-group>
      </el-form-item>
      <!-- 员工属性 -->
      <el-form-item :label="$t('formal_label')">
        <el-checkbox-group v-model="dataForm.formal">
          <el-checkbox-button
            v-for="(item, index) in sysInfoData.formal"
            :key="index"
            :value="item.key"
            :label="item.key"
          >
            {{ item.value }}
          </el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <!-- 员工在职状态 -->
      <el-form-item :label="$t('405')">
        <el-checkbox-group v-model="dataForm.state">
          <el-checkbox-button
            v-for="(item, index) in sysInfoData.state"
            :key="index"
            :value="item.key"
            :label="item.key"
          >
            {{ item.value }}
          </el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <!-- 入职时间 -->
      <el-form-item :label="$t('28')">
        <el-date-picker
          v-model="hireDate"
          type="daterange"
          :range-separator="$t('409')"
          value-format="yyyy-MM-dd"
          :start-placeholder="$t('407')"
          @change="hireDateChange"
          :end-placeholder="$t('408')"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 离职日期 -->
      <el-form-item :label="$t('29')">
        <el-date-picker
          v-model="leaveDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          :range-separator="$t('409')"
          @change="leaveDateChange"
          :start-placeholder="$t('407')"
          :end-placeholder="$t('408')"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <el-row style="text-align: center; margin-top: 20px">
      <el-button type="" size="mini" @click="doReset">{{ $t('work_rule_7') }}</el-button>
      <el-button type="primary" plain size="mini" @click="doSubmit">{{ $t('131') }}</el-button>
    </el-row>
  </el-drawer>
</template>

<script>
import { orgInfoFn, depListFn } from '@/api/org/dep'
import { sysInfoFn } from '@/api/org/per'
export default {
  name: 'searchPopup',
  props: ['pageName'],
  data() {
    return {
      visible: false,
      popover: false,
      treeList: [],
      name: '',
      treeProps: {
        label: 'department_name',
        isLeaf: 'is_sub_department'
      },
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      hireDate: '',
      leaveDate: '',
      treeCheckList: [],
      dataForm: {
        department_id: [],
        settlement_type: [],
        formal: [],
        state: [],
        hire_start_date: '',
        hire_end_date: '',
        leave_start_date: '',
        leave_end_date: ''
      },
      settlement_type: [],
      formal: [],
      state: [],
      tempDataForm: {},
      sysInfoData: {},
      isSubmit: false
    }
  },
  mounted() {
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
  },
  methods: {
    init() {
      this.visible = true
      this.sysInfoFn()
      this.getOrgInfo()
      this.defaultCheckedKeys = this.treeCheckList
      if (sessionStorage.getItem('searchResult')) {
        const searchValue = JSON.parse(sessionStorage.getItem('searchResult'))
        this.defaultCheckedKeys = searchValue.default_checked_keys.map(i => {
          return i.department_id
        })
        //  console.log(JSON.stringify(sessionStorage.getItem('searchResult')))
        Object.keys(this.dataForm).map(item => {
          if (item === 'department_id') return
          this.dataForm[item] = searchValue[item]
        })
      }
    },
    // 获取选项
    async sysInfoFn() {
      const res = await sysInfoFn()
      if (res && res.code === 1) this.sysInfoData = res.data
    },
    handleNodeClick() {
      // 选中节点
      this.treeCheckList = this.$refs.tree.getCheckedNodes()
    },
    departmentClear() {
      // 删除节点
      this.treeCheckList.splice(0, 1)
      this.$refs.tree.setCheckedNodes(this.treeCheckList)
    },
    beforeunloadHandler() {
      sessionStorage.removeItem('searchResult')
    },
    settlementTypeChange() {
      if (this.dataForm.settlement_type.length > 1) {
        this.dataForm.settlement_type.shift()
      }
    },
    async getOrgInfo() {
      const res = await orgInfoFn()
      if (res && res.code === 1) {
        this.isShowTips = !res.data.supervisor_id
        const obj = {
          department_name: res.data.department_name,
          department_id: Number(res.data.id),
          supervisor_id: res.data.supervisor_id,
          supervisor_name: res.data.supervisor_name
        }
        this.defaultExpandedKeys.push(Number(res.data.id))
        this.curNode = obj
        this.treeList = [
          {
            is_sub_department: false,
            ...obj
          }
        ]
        this.tableData = [
          {
            ...obj,
            is_sub_department: true
          }
        ]
      }
    },
    hireDateChange(v) {
      if (v) {
        const [start, end] = v
        this.dataForm.hire_start_date = start
        this.dataForm.hire_end_date = end
      } else {
        this.dataForm.hire_start_date = ''
        this.dataForm.hire_end_date = ''
      }
    },
    leaveDateChange(v) {
      if (v) {
        const [start, end] = v
        this.dataForm.leave_start_date = start
        this.dataForm.leave_end_date = end
      } else {
        this.dataForm.leave_start_date = ''
        this.dataForm.leave_end_date = ''
      }
    },
    loadNode(node, resolve) {
      if (node.data.department_id) {
        this.hasDepListFn = true
        depListFn({ department_id: node.data.department_id }).then(res => {
          this.hasDepListFn = false
          this.tableData = res.data
          resolve(
            res.data.map(v => ({
              department_name: v.department_name,
              department_id: Number(v.department_id),
              is_sub_department: !v.is_sub_department,
              staff_count: v.staff_count
            }))
          )
        })
      }
    },
    handleProcessData(data) {
      this.dataForm.settlement_type = this.dataForm.settlement_type.toString()
      this.dataForm.formal = this.dataForm.formal.toString()
      this.dataForm.state = this.dataForm.state.toString()
      return data
    },
    doReset() {
      this.isSubmit = false
      this.beforeunloadHandler()
      this.$refs.tree.setCheckedKeys([])
      this.dataForm.leave_end_date = ''
      this.dataForm.leave_start_date = ''
      this.dataForm.hire_end_date = ''
      this.dataForm.hire_start_date = ''
      this.dataForm.formal = []
      this.dataForm.state = []
      this.dataForm.settlement_type = []
      this.dataForm.department_id = []
      this.hireDate = ''
      this.leaveDate = ''
    },
    closeDrawer() {
      if (!this.isSubmit) this.doReset()
    },
    doSubmit() {
      this.isSubmit = true
      // if (this.dataForm.settlement_type.length === 0) {
      //   this.$message.error('结算方式不能为空')
      //   return
      // }
      const searchResult = {
        default_checked_keys: this.$refs.tree.getCheckedNodes(),
        settlement_type: this.dataForm.settlement_type,
        formal: this.dataForm.formal,
        state: this.dataForm.state,
        hire_start_date: this.dataForm.hire_start_date,
        hire_end_date: this.dataForm.hire_end_date,
        leave_start_date: this.dataForm.leave_start_date,
        leave_end_date: this.dataForm.leave_end_date
      }
      sessionStorage.removeItem('searchResult')
      sessionStorage.setItem('searchResult', JSON.stringify(searchResult))
      this.dataForm.department_id = []
      this.$refs.tree.getCheckedNodes().map(item => {
        this.dataForm.department_id.push({
          id: item.department_id,
          department_name: item.department_name,
          is_sub_department: item.is_sub_department
        })
      })
      this.tempDataForm = this.dataForm
      this.handleProcessData()
      this.visible = false
      this.$emit('submit', this.dataForm)
    },
    destroyed() {
      window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    }
  }
}
</script>

<style lang="less">
.search-popup {
  .el-collapse-item__header {
    padding-left: 15px;
  }
  .el-collapse-item__content {
    padding-left: 20px;
  }
  .el-drawer__header {
    margin-bottom: 15px;
    padding: 0 24px;
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
  }
  .el-form {
    height: calc(100% - 70px);
    padding: 0 24px;
    overflow: hidden;
    overflow-y: auto;
  }
  .el-form-item {
    .el-form-item__label {
      display: block;
      float: none;
      text-align: left;
      font-size: 14px;
      color: #262626;
    }
  }
  .tree {
    width: 100%;
  }
  .el-input {
    min-width: 100%;
  }
  .input {
    position: relative;
    .el-input {
      cursor: pointer;
    }
    .el-input__inner {
      caret-color: transparent;
    }
    .check-list {
      position: absolute;
      max-width: 85%;
      height: 100%;
      overflow: hidden;
      display: flex;
      top: 0px;
      left: 0px;
      .tag {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        .el-tag {
          margin: 6px 0 6px 6px;
        }
      }
      .text {
        margin-left: 6px;
      }
    }
  }
  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    .el-checkbox-button {
      width: 50%;
      display: block;
      .el-checkbox-button__inner {
        display: inline-block;
        width: 100%;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        margin-bottom: 3px;
      }
      &:nth-child(3n) {
        padding-right: 5px;
      }
      &:nth-child(2n) {
        padding-left: 5px;
      }
      &.is-checked {
        .el-checkbox-button__inner {
          border-color: #5D51DA;
        }
      }
    }
  }
  .el-date-editor {
    width: 100%;
  }
}
.tree-popover {
  max-height: 500px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
